// initial state
const state = {
  themeColor: 'theme-chalk'// 默认为element自带样式
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  // 更新主题颜色
  setThemeColor (state, curcolor) {
    state.themeColor = curcolor;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/theme.js